// Sözleşme yenileme mutationları.
export const INSERT_CONTRACT_RENEWAL_MUTATION = `
  mutation InsertContractRenewal($object: contract_renewals_insert_input!) {
    insert_contract_renewals_one(object: $object) {
      id
      contract_id
      renewal_start_date
      renewal_end_date
      new_monthly_amount
      description
    }
  }
`;
